import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SlideType } from "../Components/Helpers";
import { ITimes } from "../Types/ITimes";

export interface IPrayerTimesState {
  prayerTimes: ITimes[];
  slide: SlideType;
  apiError: boolean;
  reloadData: Date;
}

export const initialState: IPrayerTimesState = {
  prayerTimes: [],
  slide: SlideType.Loop,
  apiError: false,
  reloadData: new Date(new Date().setHours(new Date().getHours() + 1)),
};

export const PrayerTimesSlice = createSlice({
  initialState,
  name: "prayerTimes",
  reducers: {
    setPrayerTimes: (
      state: IPrayerTimesState,
      { payload }: PayloadAction<ITimes[]>
    ): void => {
      state.prayerTimes = payload;
    },
    setSlide: (
      state: IPrayerTimesState,
      { payload }: PayloadAction<SlideType>
    ): void => {
      state.slide = payload;
    },
    setApiError: (
      state: IPrayerTimesState,
      { payload }: PayloadAction<boolean>
    ): void => {
      state.apiError = payload;
    },
    setReloadData: (
      state: IPrayerTimesState,
      { payload }: PayloadAction<Date>
    ): void => {
      state.reloadData = payload;
    },
  },
});

export const prayerTimesActions = PrayerTimesSlice.actions;

export const prayerTimesReducer = PrayerTimesSlice.reducer;
